import { Container } from '@/atoms';
import { CardBanner, Grid } from '@/molecules';
import { ProductBlock } from '@/organisms';

import { CardProductAlgolia } from '@/components/algolia';
import { cardBannerTransformer } from '@/lib/graphql/transformers';
import { removeBaseURL } from '@/lib/utils';

import type {
  TypeCardBannerGraphQL,
  TypeProductAlgolia,
} from '@/lib/graphql/types';
import type { useHits } from 'react-instantsearch';

type Item =
  | ReturnType<typeof useHits<TypeProductAlgolia>>['hits'][number]
  | { id: string; cpt_banner: TypeCardBannerGraphQL };

const isBanner = (
  p: Item,
): p is { id: string; cpt_banner: TypeCardBannerGraphQL } => 'cpt_banner' in p;

const ProductsByBrand = ({ bloque, id, className }: any) => {
  const {
    titulo,
    backgroundColor,
    description,
    link,
    products,
    path,
  }: {
    titulo: string;
    backgroundColor: string;
    description: string;
    link: {
      label: string;
      link: { url: string };
      size: 'body' | 'small' | 'large';
      style: 'primary' | 'secondary' | 'alternative' | 'current-color';
    };
    products: Item[];
    path: string;
  } = bloque;

  return (
    <Container
      id={id}
      wrapper
      as="section"
      {...(backgroundColor
        ? {
            style: { backgroundColor },
            padding: 'px-4 py-8 md:py-16',
          }
        : {})}
      {...(className && { className })}
    >
      <ProductBlock
        {...(titulo ? { title: titulo } : {})}
        {...(link && link.link?.url && link?.label
          ? {
              link: {
                href: removeBaseURL(link.link.url),
                label: link.label,
                size: link.size,
                style: link.style,
              },
            }
          : {})}
        {...(description ? { description: description } : {})}
        productos={products}
        itemListName={path}
        headingType={bloque.headingType}
      >
        <Grid>
          {products.map((p, i) => {
            if (isBanner(p)) {
              p;
              return (
                <Grid.Item key={i} colSpanXXS={p.cpt_banner.double ? 2 : 1}>
                  <CardBanner {...cardBannerTransformer(p.cpt_banner)} />
                </Grid.Item>
              );
            }

            if ('sku' in p) {
              return (
                <Grid.Item key={p.id}>
                  <CardProductAlgolia
                    hit={p}
                    itemListName={path}
                    itemIndex={i + 1}
                    numColumns={6}
                  />
                </Grid.Item>
              );
            }
          })}
        </Grid>
      </ProductBlock>
    </Container>
  );
};

export default ProductsByBrand;

ProductsByBrand.displayName = 'ProductsByBrand';
